import DOMPurify from 'dompurify'

// Enhance sanitization to force external links to open in a new tab
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.getAttribute('href')) {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

// Reusable function
export const sanitizeHtml = htmlString => {
  return DOMPurify.sanitize(htmlString || '')
}
